/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var KonturBonusSignIcon16Regular = forwardRef('KonturBonusSignIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.5 1.25a.75.75 0 0 0-1.5 0V3H5.25C4.56 3 4 3.56 4 4.25v7.5c0 .69.56 1.25 1.25 1.25H7v1.75a.75.75 0 0 0 1.5 0V13H9a3 3 0 1 0 0-6H5.5V4.5h5a.75.75 0 0 0 0-1.5h-2V1.25Zm-3 10.25v-3H9a1.5 1.5 0 1 1 0 3H5.5Z" })));
});
